import { Action } from 'redux';
import { HttpRequestError, RemoteRequest } from '../../types';

export interface ParametricStore {
  country: string;
  code: string;
  store: string;
  store_name: string;
}

export interface CreateParametricStoreRequest {
  country: string;
  code: string;
  store: string;
  store_name: string;
}

export interface UpdateParametricStoreRequest {
  store: string;
  store_name: string;
}

export interface State {
  list: RemoteRequest & { data: ParametricStore[] };
  save: RemoteRequest & { data: null };
  remove: RemoteRequest & { data: null };
}

export enum ActionType {
  listRequested = 'parametricStores/listRequested',
  listSuccess = 'parametricStores/listSuccess',
  listFailure = 'parametricStores/listFailure',

  createRequested = 'parametricStores/createRequested',
  createSuccess = 'parametricStores/createSuccess',
  createFailure = 'parametricStores/createFailure',

  updateRequested = 'parametricStores/updateRequested',
  updateSuccess = 'parametricStores/updateSuccess',
  updateFailure = 'parametricStores/updateFailure',

  deleteRequested = 'parametricStores/deleteRequested',
  deleteSuccess = 'parametricStores/deleteSuccess',
  deleteFailure = 'parametricStores/deleteFailure',
}

export interface ListRequestedAction extends Action {
  type: ActionType.listRequested;
  country: string;
}
export interface ListSuccessAction extends Action {
  type: ActionType.listSuccess;
  data: ParametricStore[];
}
export interface ListFailureAction extends Action {
  type: ActionType.listFailure;
  error: HttpRequestError;
}

export interface CreateRequestedAction extends Action {
  type: ActionType.createRequested;
  payload: CreateParametricStoreRequest;
}
export interface CreateSuccessAction extends Action {
  type: ActionType.createSuccess;
  data: ParametricStore;
}
export interface CreateFailureAction extends Action {
  type: ActionType.createFailure;
  error: HttpRequestError;
}

export interface UpdateRequestedAction extends Action {
  type: ActionType.updateRequested;
  country: string;
  code: string;
  payload: UpdateParametricStoreRequest;
}
export interface UpdateSuccessAction extends Action {
  type: ActionType.updateSuccess;
  country: string;
  code: string;
  payload: UpdateParametricStoreRequest;
}
export interface UpdateFailureAction extends Action {
  type: ActionType.updateFailure;
  error: HttpRequestError;
}

export interface DeleteRequestedAction extends Action {
  type: ActionType.deleteRequested;
  country: string;
  code: string;
}
export interface DeleteSuccessAction extends Action {
  type: ActionType.deleteSuccess;
  country: string;
  code: string;
}
export interface DeleteFailureAction extends Action {
  type: ActionType.deleteFailure;
  error: HttpRequestError;
}

export type Actions =
  | ListRequestedAction
  | ListSuccessAction
  | ListFailureAction
  | CreateRequestedAction
  | CreateSuccessAction
  | CreateFailureAction
  | UpdateRequestedAction
  | UpdateSuccessAction
  | UpdateFailureAction
  | DeleteRequestedAction
  | DeleteSuccessAction
  | DeleteFailureAction;
